/*
 *  Osano Cookie Policy
 *  CSS & Javascript Implementation Included
 *
 */


export function scrollanimation(setElems) {

  // Run funntion if in viewport
  elementInViewport(setElems);

  // Check if elem in viewport
  function elementInViewport(setElems) {
    setElems.forEach((elem)=>{
      let bounding = elem.getBoundingClientRect();
      let myElementHeight = elem.offsetHeight;
      let myElementWidth = elem.offsetWidth;

      if (bounding.top >= -myElementHeight 
          && bounding.left >= -myElementWidth
          && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
          && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) {
          animateOnLoad(setElems);
      } else {
          scrollContainer(setElems);
      }
    });
  }

  function scrollContainer(setElems) { 
    window.addEventListener("scroll", function() {
      setElems.forEach(function(elem) {
        var vwTop = window.pageYOffset;
        var vwBottom = (window.pageYOffset + window.innerHeight);
        var elemTop = elem.offsetTop;
        var myElementHeight = elem.offsetHeight;
        var myElementWidth = elem.offsetWidth;
        let bounding = elem.getBoundingClientRect();

        if (bounding.top >= -myElementHeight 
            && bounding.left >= -myElementWidth
            && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + myElementWidth
            && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + myElementHeight) {
            elem.classList.add("animate__animated");
        } else {
            elem.classList.remove("animate__animated");
        }
      });
    }, false);
  }

  function animateOnLoad(setElems) {
    window.addEventListener('load', (e) => {

      setElems.forEach(function (elem, index) {
        
        elem.classList.add("animate__animated");
      
      });
    });
  }
}
